import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import AppIcon from './AppIcon';

function TermsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="app animated-dots">
      {/* Animated dots */}
      <div className="dot"></div>
      <div className="dot"></div>
      <div className="dot"></div>
      <div className="dot"></div>
      <div className="dot"></div>
      <div className="dot"></div>
      <div className="dot"></div>
      <div className="dot"></div>

      {/* Main Content */}
      <div className="main-content">
        {/* Header with icon */}
        <div className="page-header">
          <Link to="/" className="page-icon-container">
            <AppIcon size={70} />
          </Link>
        </div>

        {/* Terms Content */}
        <div className="page-content">
          <h1 className="page-title">Terms of Service</h1>
          
          <div className="content-section">
            <section className="mb-8">
              <h2 className="section-title">1. Acceptance of Terms</h2>
              <p className="section-text">
                By accessing and using ControllerApp, you accept and agree to be bound by the terms and provision of this agreement.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="section-title">2. Use License</h2>
              <p className="section-text">
                Permission is granted to temporarily download one copy of ControllerApp per device for personal, non-commercial transitory viewing only.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="section-title">3. Disclaimer</h2>
              <p className="section-text">
                The materials on ControllerApp are provided on an 'as is' basis. ControllerApp makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="section-title">4. Limitations</h2>
              <p className="section-text">
                In no event shall ControllerApp or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use ControllerApp.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="section-title">5. Privacy Policy</h2>
              <p className="section-text">
                Your use of ControllerApp is also governed by our Privacy Policy. Please review our{' '}
                <Link to="/privacy" className="link-text">
                  Privacy Policy
                </Link>.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="section-title">6. Trademark Disclaimer</h2>
              <p className="section-text">
                This app is not affiliated with or endorsed by MA Lighting. All trademarks and copyrights belong to their respective owners. GrandMA2/3 and all related marks are trademarks of MA Lighting Technology GmbH.
              </p>
            </section>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-divider"></div>
          <div className="footer-links">
            <Link to="/terms" className="footer-link">
              Terms of Service
            </Link>
            <Link to="/privacy" className="footer-link">
              Privacy Policy
            </Link>
          </div>
          <p>© 2025 ControllerApp. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}

export default TermsPage;
